import React from 'react';
import { Youtube, Calendar, Eye } from 'lucide-react';
import type { Video } from '../services/youtube';

interface VideoCardProps {
  video: Video & {
    onSelect?: (video: Video) => void;
  };
}

export function VideoCard({ video }: VideoCardProps) {
  return (
    <button 
      onClick={() => video.onSelect?.(video)}
      className="group bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow w-full text-left"
    >
      <div className="relative aspect-video">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-opacity" />
        <span className="absolute bottom-3 right-3 bg-black bg-opacity-75 text-white px-3 py-1 rounded-lg text-sm font-medium">
          {video.duration}
        </span>
      </div>
      
      <div className="p-5">
        <div className="flex items-start gap-3">
          <Youtube className="h-5 w-5 text-red-600 flex-shrink-0 mt-1" />
          <div className="space-y-2">
            <h3 className="font-semibold text-gray-900 dark:text-white line-clamp-2 leading-snug">
              {video.title}
            </h3>
            <p className="text-sm text-indigo-600 dark:text-indigo-400 font-medium">
              {video.channel}
            </p>
            <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
              <div className="flex items-center gap-1">
                <Eye className="h-4 w-4" />
                <span>{video.views}</span>
              </div>
              <div className="flex items-center gap-1">
                <Calendar className="h-4 w-4" />
                <span>{video.publishedAt}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </button>
  );
}
